import script from "./OverlaySpinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./OverlaySpinner.vue?vue&type=script&lang=ts&setup=true"

import "./OverlaySpinner.vue?vue&type=style&index=0&id=53839f93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53839f93"]])

export default __exports__